import styled from "styled-components";
import theme from "../../../Themes/light";
import { ThemeType } from "../../../types/Theme";

export const ContainerFacebookPixel = styled.div<{ theme: ThemeType }>`
  width: 100%;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .textoMeta{
    text-align: left;
    padding: 3rem 0;
    color: ${(props) => props.theme.colors.tertiary};
    position: relative;
    width: 100%;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        height: 2px;
        border-radius: 100%;
        background-color: ${(props) => props.theme.colors.elements};
      }
  }

  .box{
    padding: 4rem 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    .input{
        width: 100%;
    }
    .texto-input{
    width: 100%;
    text-align: left;
    color: ${(props) => props.theme.colors.tertiary};
  }
    .botao{
        display: flex;
        justify-content: flex-end;
        width: 100%;
  
    }
  }
  .texto-input{
    width: 100%;
    text-align: left;
    color: ${(props) => props.theme.colors.tertiary};
  }
`;